import { createInputFrame, EMPTY_INPUT_FRAME } from '../../core';
import type { InputFrame } from '../../core';

export const GAMEPAD_DEADZONE = 0.25;
export const mapGamepad = (pad: Gamepad | null | undefined): InputFrame => {
  if (pad === null || pad === undefined || !pad.connected) return EMPTY_INPUT_FRAME;
  const axisX = pad.axes[0] ?? 0; const axisY = pad.axes[1] ?? 0;
  const pressed = (index: number): boolean => pad.buttons[index]?.pressed === true;
  return createInputFrame({
    left: pressed(14) || axisX < -GAMEPAD_DEADZONE, right: pressed(15) || axisX > GAMEPAD_DEADZONE,
    down: pressed(13) || axisY > GAMEPAD_DEADZONE, jump: pressed(12) || axisY < -GAMEPAD_DEADZONE,
    light: pressed(0), heavy: pressed(1), skill1: pressed(2), skill2: pressed(3),
    guard: pressed(5), super: pressed(7),
  });
};
export class GamepadInputAdapter {
  public sample(index: number): InputFrame { return mapGamepad(globalThis.navigator.getGamepads?.()[index]); }
}
